export const heroItems = [
  {
    id: "BGH-240901",
    no: "01",
    cat: "合约门",
    seal: "证据链已闭环",
    title: "顶流主播深夜晒合同，逐页核对后露出 23 处疑点",
    summary: "从解约函到分红附表，截图按页比对，排他条款与公开说法相互打架，本轮已收锤。",
    cover: "https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20investigation%20scene%20of%20a%20legal%20contract%20document%20with%20red%20seal%20stamps%20and%20signature%20lines%2C%20laid%20on%20aged%20paper%20desk%20with%20dim%20warm%20desk%20lamp%2C%20moody%20low%20key%20lighting%2C%20close%20up%20detail%20of%20printed%20clauses%20and%20fingerprint%20marks%2C%20dark%20charcoal%20and%20rust%20red%20palette%2C%20cinematic%20mystery%20atmosphere%2C%20high%20detail%20editorial%20photography&width=640&height=800&seq=bage-hero-contract&orientation=portrait",
  },
  {
    id: "BGH-240902",
    no: "02",
    cat: "言行对照",
    seal: "同框时间冲突",
    title: "代言人台上谈理念，幕后会议议程却在拆台",
    summary: "品牌商内部日程表流出，与公开通稿发言存在 3 处时间错位，对照记录已归档。",
    cover: "https://readdy.ai/api/search-image?query=A%20contrasting%20editorial%20duo%20image%20showing%20one%20person%20speaking%20on%20stage%20behind%20a%20podium%20versus%20a%20flipped%20flipped%20empty%20meeting%20room%20table%20with%20scattered%20agenda%20papers%2C%20split%20composition%2C%20warm%20spotlight%20against%20cool%20shadows%2C%20documentary%20reportage%20style%2C%20charcoal%20and%20amber%20tones%2C%20high%20detail%20photojournalism&width=640&height=800&seq=bage-hero-brand&orientation=portrait",
  },
  {
    id: "BGH-240903",
    no: "03",
    cat: "时间轴",
    seal: "口径多处打架",
    title: "跨界艺人口径与航班行程，三处时间对不上",
    summary: "采访自述与出行单据交叉比对，三个关键节点自相矛盾，时间轴推演正在进行。",
    cover: "https://readdy.ai/api/search-image?query=A%20cinematic%20airport%20terminal%20clock%20and%20departure%20board%20at%20night%2C%20blurred%20figure%20walking%20away%20with%20a%20rolling%20luggage%2C%20overlaid%20sense%20of%20timeline%20and%20schedule%2C%20neon%20flights%20board%20reflection%2C%20moody%20teal%20and%20deep%20shadow%2C%20suspenseful%20editorial%20photography%2C%20documentary%20grain&width=640&height=800&seq=bage-hero-timeline&orientation=portrait",
  },
  {
    id: "BGH-240904",
    no: "04",
    cat: "社媒痕迹",
    seal: "互关链重合 91%",
    title: "匿名小号现形，与正主互关链重合度 91%",
    summary: "账号建立、点赞时段与设备指纹逐项比对，匿名马甲与本人指向高度一致。",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20dark%20close%20up%20of%20a%20smartphone%20screen%20showing%20a%20messaging%20thread%20with%20blurred%20avatars%20and%20anonymous%20account%20icons%2C%20red%20notification%20badges%2C%20shallow%20depth%20of%20field%2C%20night%20room%20with%20soft%20backlight%2C%20warm%20screen%20glow%20against%20dark%20background%2C%20mystery%20investigation%20vibe%2C%20high%20detail%20editorial%20photography&width=640&height=800&seq=bage-hero-social&orientation=portrait",
  },
];

export const recording = [
  { label: "已收锤·锤文", value: "1286" },
  { label: "留证·截图", value: "40231" },
  { label: "重建·时间轴", value: "517" },
  { label: "复核·闭环率", value: "86%" },
];

export const collectionColumns = [
  {
    cat: "合约门",
    count: "214",
    lead: "合同、解约函、分成附表逐页核对，权益与说法逐条对质。",
    tone: "primary",
  },
  {
    cat: "言行对照",
    count: "188",
    lead: "台上发言与幕后动作放在同一张桌上，矛盾点一眼可见。",
    tone: "accent",
  },
  {
    cat: "时间轴推理",
    count: "517",
    lead: "把采访、行程、发文时间钉进同一根轴，谁先谁后自有答案。",
    tone: "primary",
  },
  {
    cat: "社媒痕迹",
    count: "302",
    lead: "账号、小号、点赞时段、设备指纹，关系的密度量化给你看。",
    tone: "secondary",
  },
  {
    cat: "资本关系",
    count: "97",
    lead: "股权穿透到第七层，谁在背后站台，一图拉平不绕弯。",
    tone: "accent",
  },
  {
    cat: "名誉澄清",
    count: "76",
    lead: "被误伤也记录在案，反方回应与硬证据一起并排陈列。",
    tone: "secondary",
  },
];

export const evidenceSteps = [
  {
    step: "第一环",
    key: "爆料",
    title: "匿名贴首爆，只说三分话",
    body: "起点是一条语焉不详的帖子，指向某位正被力捧的跨界新人，模糊但留足了钩子。",
  },
  {
    step: "第二环",
    key: "交叉核对",
    title: "与公开记录对质，矛盾浮出",
    body: "把爆料里的每个时间点拉去比对采访、行程与公司通稿，三处口径先于截图出现了裂缝。",
  },
  {
    step: "第三环",
    key: "截图留证",
    title: "逐屏留证，按页归档",
    body: "合同、聊天、后台、发布记录分门别类截图存证，标注来源与拍摄时间，不做任何口头转述。",
  },
  {
    step: "第四环",
    key: "时间轴重建",
    title: "钉进同一根轴，顺序自动现形",
    body: "所有碎片按先后落位，谁先发声、谁后删帖、谁中途改口，先后关系一目了然。",
  },
  {
    step: "第五环",
    key: "定性",
    title: "一锤到底，或还一个清白",
    body: "证据闭环的收锤下结论，证据不足的同样写清留白，宁可慢，不冤枉也不放水。",
  },
];

export const timelineEvents = [
  {
    time: "第 0 小时",
    tag: "同框",
    title: "一张后台合照开始发酵",
    body: "工作照里两人同框，本无异常，却被剪辑成暧昧片段，讨论热度开始爬坡。",
  },
  {
    time: "第 8 小时",
    tag: "回应",
    title: "一方连夜发了模棱两可的声明",
    body: "声明既没否认也没坐实，措辞里藏着三处和行程记录对不上的时间点。",
  },
  {
    time: "第 19 小时",
    tag: "删帖",
    title: "关键原帖突然被大批下架",
    body: "集中删帖的节奏本身就成了线索，后台操作时段与所谓「无辜」口径形成对照。",
  },
  {
    time: "第 32 小时",
    tag: "反转",
    title: "原始物料被重新挖出",
    body: "被删内容以缓存形式重新出现，逐帧与声明逐字比对，结论开始松动。",
  },
  {
    time: "第 48 小时",
    tag: "收束",
    title: "证据归位，此锤定性",
    body: "所有碎片收进同一根时间轴，先后与因果自动归位，本期推演画下句点。",
  },
];

export const heatItems = [
  {
    rank: "01",
    title: "新人资源位疑为「对赌换台」，权益明细待出",
    summary: "档期、分成与宣传排期被指内部置换，相关截图已被收进合约门专栏。",
    delta: "24h 内",
  },
  {
    rank: "02",
    title: "带货大V「供应链翻车」后再开播，话术变化被逐条留存",
    summary: "从「绝不售假」到「看错批次」，前后通稿措辞变化被做成对照长图。",
    delta: "48h 内",
  },
  {
    rank: "03",
    title: "选秀导师被扒与参赛者同款行程，时间轴正在重建",
    summary: "跨城出行记录与「偶然同台」的说法存在两处矛盾，尚未定性。",
    delta: "推演中",
  },
  {
    rank: "04",
    title: "老牌制作人被指「一稿多用」，署名与采买记录打架",
    summary: "两档节目文案段落重合度过高，版权侧截图已进入复核队列。",
    delta: "复核中",
  },
  {
    rank: "05",
    title: "「好爸爸」人设翻车？亲子行程被逐日核对",
    summary: "公开陪伴叙述与工作排期相抵，是否误伤仍在证据链审查阶段。",
    delta: "待定性",
  },
  {
    rank: "06",
    title: "某厂牌成团夜排位「剧本论」再起，投票时间戳重算",
    summary: "票数爬升曲线与发博时段高度重合，数据侧推演已进入第二环。",
    delta: "推演中",
  },
];

export const disclaimerList = [
  "本页以「锤文 + 截图 + 时间轴」形式陈列公开可查的素材与推理过程，旨在厘清事件脉络，不预设立场。",
  "文中人物均以化名、代号与工作身份呈现，未指向任何现实自然人；请勿对号入座、扩散臆测。",
  "所有截图与记录均标注来源与时间，疑点存疑处一律写清留白，不补脑补戏。",
  "若当事人或相关方认为存在失实，欢迎凭有效凭证提出勘误，我们将对证据链重新复核并公开更正。",
  "本页收录以公开信息整理为限，不产出、不传播任何未经证实的人格贬损内容，请理性吃瓜、理性浏览。",
];